// extracted by mini-css-extract-plugin
export default {"wrapper":"DataProcessingPolicy_wrapper__PnRFz","aside":"DataProcessingPolicy_aside__vMSFf","nav":"DataProcessingPolicy_nav__pCXGO","content":"DataProcessingPolicy_content__YXG+d"};